var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductHeader',{attrs:{"title":"Detalle de Producto"}}),_c('ProductForm',{attrs:{"product":_vm.product},on:{"onUpdate":_vm.onUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }